import React from 'react';
import { func, node } from 'prop-types';
import style from './style.module.scss';

const Disclaimer = ({ hasRead, children }) => {
  const handleScroll = (e) => {
    const { currentTarget } = e;
    if (currentTarget.offsetHeight + currentTarget.scrollTop >= currentTarget.scrollHeight) {
      if (hasRead) {
        hasRead(true);
      }
    }
  };

  return (
    <div className={style.Disclaimer} onScroll={handleScroll}>
      <div className={style.DisclaimerCopy}>{children}</div>
    </div>
  );
};

Disclaimer.propTypes = {
  hasRead: func,
  children: node.isRequired,
};

Disclaimer.defaultProps = {
  hasRead: null,
};

export default Disclaimer;
